import { lazy, Suspense } from "react";
import { LoadingC } from "src/shared/components";
// @ts-ignore
const loadable = (
  importFunc: any,
  { fallback = null } = { fallback: null }
) => {
  const LazyComponent = lazy(importFunc);



  return (props: any) => (
    <Suspense fallback={<LoadingC />}>
      {/* <ErrorBoundary> */}
      <LazyComponent {...props} />
      {/* </ErrorBoundary> */}
    </Suspense>
  );
};

export default loadable;
